import {
  PublicDemandInterestFormDetails,
  SendPublicDemandInterestFormResponse,
} from '@features/public-demand-interest-form/utils/models/public-demand-interest-form.model';
import { Action, MetaReducer, createReducer } from '@ngrx/store';
import { HttpStateHandler } from '@shared/utils/classes/http-state-handler';
import { produceOn, transferStateMetaReducer } from '@shared/utils/functions/store.function';
import { HttpState } from '@shared/utils/models/http.model';
import {
  PublicDemandInterestFormActions,
  PublicDemandInterestFormResetActions,
} from '../actions/public-demand-interest-form.actions';

export const publicDemandInterestFormFeatureKey = 'publicDemandInterestForm';

export interface State {
  demandHash: string | null;
  data: PublicDemandInterestFormDetails | null;
  httpState: HttpState;
  send: {
    httpState: HttpState;
    data: SendPublicDemandInterestFormResponse | null;
  };
}

export const initialState: State = {
  demandHash: null,
  data: null,
  httpState: HttpStateHandler.initialState,
  send: {
    httpState: HttpStateHandler.initialState,
    data: null,
  },
};

export const publicDemandInterestFormReducer = createReducer(
  initialState,
  produceOn(PublicDemandInterestFormActions.validateDemandInterestForm, (draft, action) => {
    draft.demandHash = action.demandHash;
    draft.data = initialState.data;
    draft.httpState = HttpStateHandler.loading(draft.httpState, action);
  }),
  produceOn(PublicDemandInterestFormActions.validateDemandInterestFormSuccess, (draft, action) => {
    draft.data = action.data;
    draft.httpState = HttpStateHandler.success(draft.httpState, action);
  }),
  produceOn(PublicDemandInterestFormActions.validateDemandInterestFormFailure, (draft, action) => {
    draft.httpState = HttpStateHandler.error(draft.httpState, action);
  }),
  produceOn(PublicDemandInterestFormActions.sendDemandInterestForm, (draft, action) => {
    draft.send.data = initialState.send.data;
    draft.send.httpState = HttpStateHandler.loading(draft.send.httpState, action);
  }),
  produceOn(PublicDemandInterestFormActions.sendDemandInterestFormSuccess, (draft, action) => {
    draft.send.data = action.data;
    draft.send.httpState = HttpStateHandler.success(draft.send.httpState, action);
  }),
  produceOn(PublicDemandInterestFormActions.sendDemandInterestFormFailure, (draft, action) => {
    draft.send.httpState = HttpStateHandler.error(draft.send.httpState, action);
  }),
  produceOn(PublicDemandInterestFormResetActions.cancelPublicDemandInterestFormActionsSuccess, (draft) => {
    draft.httpState = HttpStateHandler.initialState;
  }),
  produceOn(PublicDemandInterestFormResetActions.resetPublicDemandInterestForm, (draft) => {
    draft.demandHash = initialState.demandHash;
    draft.data = initialState.data;
    draft.httpState = initialState.httpState;
    draft.send = initialState.send;
  })
);

export function reducer(state: State | undefined, action: Action) {
  return publicDemandInterestFormReducer(state, action);
}

export const metaReducers: MetaReducer<State>[] = [
  transferStateMetaReducer(publicDemandInterestFormFeatureKey, initialState, false),
];
